import { UserModule } from "./UserModule";

export class OrganisatieModule {

    /**
     * Naam en logo van de organisatie waarin je werkt. Publiek bruikbaar (de
     * deelnemerspagina heeft dit nodig vóór het inloggen), maar we sturen het token
     * mee als dat er is: alleen dan kan de server de organisatiekeuze van een
     * superbeheerder honoreren.
     */
    static huidige() {
        const token = localStorage.getItem('token');
        const headers = { 'Content-type': 'application/json' };

        if (token) {
            headers.Authorization = 'Bearer ' + token;
        }

        return fetch('api/Organisatie/Huidige', { headers }).then(res => res.json());
    }

    /**
     * Het webadres waarop de deelnemers van dit toernooi thuishoren.
     *
     * Bewust niet window.location: dat is het adres waar de beheerder toevallig zit.
     * Een superbeheerder kan via de organisatiekiezer in een andere vereniging werken
     * dan het subdomein in zijn adresbalk, en dan zou elke QR-code naar het verkeerde
     * subdomein wijzen — waar die toernooicode niet bestaat.
     */
    static toernooiAdres(tournamentId) {
        return fetch(`api/Organisatie/ToernooiAdres?tournamentId=${tournamentId}`, {
            headers: {
                'Content-type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('token'),
            },
        }).then(res => res.json());
    }

    static getAllOrganisaties() {
        return fetch('api/Organisatie/GetAllOrganisaties', {
            headers: {
                'Content-type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            }
        }).then(res => UserModule.checkIfAuthorized(res));
    }

    static addOrEditOrganisatie(id, naam, subdomein, actief) {
        return fetch('api/Organisatie/AddOrEditOrganisatie', {
            method: 'POST',
            headers: {
                'Content-type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            },
            body: JSON.stringify({ id: id || 0, naam, subdomein, actief })
        }).then(res => UserModule.checkIfAuthorized(res));
    }

    /** Kan alleen als de organisatie nog geen toernooien heeft; de server bewaakt dat. */
    static verwijderOrganisatie(organisatieId) {
        return fetch('api/Organisatie/VerwijderOrganisatie', {
            method: 'POST',
            headers: {
                'Content-type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            },
            body: JSON.stringify({ id: organisatieId })
        }).then(res => UserModule.checkIfAuthorized(res));
    }

    static getOrganisatie(organisatieId) {
        return fetch(`api/Organisatie/GetOrganisatie?organisatieId=${organisatieId}`, {
            headers: {
                'Content-type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            }
        }).then(res => UserModule.checkIfAuthorized(res));
    }

    static zetHuisstijl(huisstijl) {
        return fetch('api/Organisatie/ZetHuisstijl', {
            method: 'POST',
            headers: {
                'Content-type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            },
            body: JSON.stringify(huisstijl)
        }).then(res => UserModule.checkIfAuthorized(res));
    }

    /** soort: 'logo' (breed), 'icoon' (vierkant) of 'deelafbeelding'. */
    static uploadAfbeelding(organisatieId, soort, bestand) {
        const formulier = new FormData();
        formulier.append('file', bestand);
        formulier.append('organisatieId', organisatieId);
        formulier.append('soort', soort);

        return fetch('api/Organisatie/UploadAfbeelding', {
            method: 'POST',
            headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') },
            body: formulier
        }).then(res => UserModule.checkIfAuthorized(res));
    }

    static addOrganisatiebeheerder(organisatieId, gebruikersnaam, wachtwoord) {
        return fetch('api/Organisatie/AddOrganisatiebeheerder', {
            method: 'POST',
            headers: {
                'Content-type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            },
            body: JSON.stringify({ organisatieId, gebruikersnaam, wachtwoord })
        }).then(res => UserModule.checkIfAuthorized(res));
    }
}
